import { createActions } from 'redux-actions';
import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../lib/reduxActionsUtils';
import { Dispatch } from 'redux';
import paymentsApi from '../../api/paymentsApi';

export const { getAccountIntentPending, getAccountIntentFullfilled, getAccountIntentRejected } = createActions(
  actionTypes.GET_ACCOUNT_INTENT_FULLFILLED,
  actionTypes.GET_ACCOUNT_INTENT_PENDING,
  actionTypes.GET_ACCOUNT_INTENT_REJECTED,
  getActionOptions(ACTION_PREFIX)
);

const getAccountIntentSummary = (id: string) => async (dispatch: Dispatch<any>) => {
  dispatch(getAccountIntentPending());
  try {
    const response = await paymentsApi.getAccountIntentSummary(id);
    return dispatch(getAccountIntentFullfilled(response));
  } catch (error) {
    return dispatch(getAccountIntentRejected(error));
  }
};

export default {
  getAccountIntentSummary,
};
